import {Controller} from "stimulus";
import Datepicker from 'vanillajs-datepicker/js/Datepicker';
import DateRangePicker from 'vanillajs-datepicker/js/DateRangePicker';
import de from 'vanillajs-datepicker/js/i18n/locales/de'

let en = {
  'en-US': {
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    today: "Today",
    clear: "Clear",
    titleFormat: "MM y",
    format: "dd-mm-yyyy",
    weekStart: 0
  }
}

Object.assign(Datepicker.locales, de, en);

export default class extends Controller {
  static targets = []

  get languages() {
    return {
      en: 'en-US',
      de: 'de',
    }
  }

  connect() {
    let language = document.querySelector('html').getAttribute('lang');

    this.daterangepicker = new DateRangePicker(this.element, {
      language: this.languages[language],
      buttonClass: 'btn',
      autohide: true,
      disableTouchKeyboard: true,
      calendarWeeks: true
    });
  }

  disconnect() {
    this.daterangepicker.destroy()
  }
}
